import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

const TIPOS = [
  { value: '01', label: 'DINHEIRO' },
  { value: '02', label: 'CHEQUE' },
  { value: '03', label: 'CARTÃO DE CRÉDITO' },
  { value: '04', label: 'CARTÃO DE DÉBITO' },
  { value: '05', label: 'CRÉDITO LOJA' },
  { value: '10', label: 'VALE ALIMENTAÇÃO' },
  { value: '11', label: 'VALE REFEIÇÃO' },
  { value: '12', label: 'VALE PRESENTE' },
  { value: '13', label: 'VALE COMBUSTÍVEL' },
  { value: '15', label: 'BOLETO' },
  { value: '16', label: 'DEPÓSITO' },
  { value: '17', label: 'PIX' },
  { value: '18', label: 'CARTEIRA DIGITAL' },
  { value: '19', label: 'PROGRAMA FIDELIDADE' },
  { value: '90', label: 'SEM PAGAMENTO' },
  { value: '99', label: 'OUTROS' },
];

const FORMAS = [
  { value: '0', label: 'À vista' },
  { value: '1', label: 'A prazo' },
];

const PLATAFORMAS = [
  { value: 'REDE', label: 'REDE' },
  { value: 'CONEXAOPIX', label: 'CONEXÃO PIX' },
  { value: 'PAGSEGURO', label: 'PAGSEGURO' },
  { value: 'CIELO', label: 'CIELO' },
  { value: 'SMARTTEF', label: 'AUTOTEF' },
  { value: 'STONE', label: 'STONE' },
  { value: 'SAFRAPAY', label: 'SAFRAPAY' },
  { value: 'GETNET', label: 'GETNET' },
  { value: 'LOCALTEF', label: 'TEF TRADICIONAL' },
  { value: 'MULTPAG', label: 'MULTIPAG' },
  { value: 'SITEF', label: 'SITEF' },
  { value: 'VERO', label: 'VERO' },
  { value: 'ADIQ', label: 'ADIQ' },
  { value: 'ZOOP', label: 'ZOOP' },
  { value: 'BANRICOMPRAS', label: 'BANRICOMPRAS' },
];

const TPINTEGRA = [
  { value: '', label: 'Sem integração' },
  { value: '1', label: 'TEF' },
  { value: '2', label: 'POS' },
];

// Função para garantir que permissoes sempre seja um objeto válido
const safeParsePermissoes = (val) => {
  try {
    if (!val) return { permite_troco: false, autoatendimento: false };
    if (typeof val === 'object') return val;
    const parsed = JSON.parse(val);
    return typeof parsed === 'object' ? parsed : { permite_troco: false, autoatendimento: false };
  } catch {
    return { permite_troco: false, autoatendimento: false };
  }
};

function EmpresaFinalizadorasPage({ empresa, usuario, onVoltar, onSair }) {
  const [finalizadoras, setFinalizadoras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({
    id: null,
    nome: '',
    indpag: '0',
    tipo: '',
    plataforma: '',
    tpintegra: '',
    credenciais: '',
    token_maquina: '',
    cnpj_adm: '',
    permissoes: { permite_troco: false, autoatendimento: false },
    emite_nfc_automatico: false
  });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });
  const [modalImportar, setModalImportar] = useState(false);
  const [finalizadorasImport, setFinalizadorasImport] = useState([]);
  const [selecionadasImport, setSelecionadasImport] = useState([]);
  const [importando, setImportando] = useState(false);

  const fetchFinalizadoras = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/finalizadoras?empresa_id=${empresa.id}`);
      const data = await res.json();
      setFinalizadoras(Array.isArray(data) ? data : []);
    } catch (err) {
      setFinalizadoras([]);
      setErro('Erro ao buscar finalizadoras');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFinalizadoras();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (fin = null) => {
    if (fin) {
      setForm({
        ...fin,
        permissoes: safeParsePermissoes(fin.permissoes),
        emite_nfc_automatico: !!fin.emite_nfc_automatico
      });
      setEditando(true);
    } else {
      setForm({
        id: null,
        nome: '',
        indpag: '0',
        tipo: '',
        plataforma: '',
        tpintegra: '',
        credenciais: '',
        token_maquina: '',
        cnpj_adm: '',
        permissoes: { permite_troco: false, autoatendimento: false },
        emite_nfc_automatico: false
      });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({
      id: null,
      nome: '',
      indpag: '0',
      tipo: '',
      plataforma: '',
      tpintegra: '',
      credenciais: '',
      token_maquina: '',
      cnpj_adm: '',
      permissoes: { permite_troco: false, autoatendimento: false },
      emite_nfc_automatico: false
    });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value, checked } = e.target;
    if (name === 'permite_troco' || name === 'autoatendimento') {
      setForm(f => ({ ...f, permissoes: { ...f.permissoes, [name]: checked } }));
    } else if (name === 'emite_nfc_automatico') {
      setForm(f => ({ ...f, emite_nfc_automatico: checked }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.nome || !form.tipo) {
      setErro('Preencha os campos obrigatórios!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/finalizadoras/${form.id}` : `${API_URL}/finalizadoras`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          nome: form.nome,
          indpag: form.indpag,
          tipo: form.tipo,
          plataforma: form.plataforma,
          tpintegra: form.tpintegra,
          credenciais: form.credenciais,
          token_maquina: form.token_maquina,
          cnpj_adm: form.cnpj_adm,
          permissoes: JSON.stringify(form.permissoes),
          emite_nfc_automatico: form.emite_nfc_automatico
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar finalizadora');
      fecharModal();
      fetchFinalizadoras();
    } catch (err) {
      setErro('Erro ao salvar finalizadora');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/finalizadoras/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchFinalizadoras();
    } catch {
      setErro('Erro ao remover finalizadora');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Ordenar finalizadoras por nome (principal)
  const finalizadorasOrdenadas = Array.isArray(finalizadoras)
    ? [...finalizadoras].sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt', { sensitivity: 'base' }))
    : [];
  const finalizadorasFiltradas = finalizadorasOrdenadas.filter(f => f.nome.toLowerCase().includes(pesquisa.toLowerCase()));

  const abrirModalImportar = async () => {
    setModalImportar(true);
    setImportando(false);
    setSelecionadasImport([]);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/finalizadoras?empresa_id=99999999`);
      const data = await res.json();
      setFinalizadorasImport(Array.isArray(data) ? data : []);
    } catch {
      setFinalizadorasImport([]);
      setErro('Erro ao buscar finalizadoras para importar');
    }
  };

  const fecharModalImportar = () => {
    setModalImportar(false);
    setFinalizadorasImport([]);
    setSelecionadasImport([]);
    setErro('');
  };

  const toggleSelecionada = (id) => {
    setSelecionadasImport(sel => sel.includes(id) ? sel.filter(x => x !== id) : [...sel, id]);
  };

  // Ordenar finalizadoras de importação por nome
  const finalizadorasImportOrdenadas = Array.isArray(finalizadorasImport)
    ? [...finalizadorasImport].sort((a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt', { sensitivity: 'base' }))
    : [];

  const confirmarImportacao = async () => {
    setImportando(true);
    setErro('');
    const selecionados = finalizadorasImport.filter(f => selecionadasImport.includes(f.id));
    if (!selecionados.length) {
      setErro('Selecione ao menos uma finalizadora para importar!');
      setImportando(false);
      return;
    }
    try {
      const res = await fetch(`${API_URL}/finalizadoras/importar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ empresa_id: empresa.id, finalizadoras: selecionados })
      });
      if (!res.ok) throw new Error('Erro ao importar finalizadoras');
      fecharModalImportar();
      fetchFinalizadoras();
    } catch {
      setErro('Erro ao importar finalizadoras');
    }
    setImportando(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Finalizadoras</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por nome..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {finalizadorasFiltradas.map(f => (
              <div key={f.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{f.nome}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(f)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(f.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Forma:</b> {FORMAS.find(x => x.value === String(f.indpag))?.label || '-'}</div>
                <div className="text-gray-700 mb-1"><b>Tipo:</b> {TIPOS.find(x => x.value === f.tipo)?.label || '-'}</div>
                <div className="text-gray-700 mb-1"><b>Plataforma:</b> {PLATAFORMAS.find(x => x.value === f.plataforma)?.label || '-'}</div>
                <div className="text-gray-700 mb-1"><b>Tipo Integração:</b> {TPINTEGRA.find(x => x.value === String(f.tpintegra))?.label || '-'}</div>
                <div className="text-gray-700 mb-1"><b>Permissões:</b> {(() => {
                  const p = safeParsePermissoes(f.permissoes);
                  return (p.permite_troco ? 'TROCO ' : '') + (p.autoatendimento ? 'AUTOATENDIMENTO' : '') || '-';
                })()}</div>
                <div className="text-gray-700 mb-1"><b>Emite NFC-e automático:</b> {f.emite_nfc_automatico ? 'Sim' : 'Não'}</div>
              </div>
            ))}
            {finalizadorasFiltradas.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhuma finalizadora encontrada.</div>
            )}
          </div>
        )}
        {/* Botões flutuantes padrão do sistema */}
        <div className="fixed bottom-8 right-8 flex flex-col gap-4 z-50">
          <button
            onClick={() => abrirModal()}
            className="bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition"
            title="Nova Finalizadora"
          >
            +
          </button>
          <button
            onClick={abrirModalImportar}
            className="bg-green-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-2xl hover:bg-green-700 transition"
            title="Importar Finalizadoras"
          >
            <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v12m0 0l-6-6m6 6l6-6" />
            </svg>
          </button>
        </div>
        {/* Modal */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Finalizadora' : 'Nova Finalizadora'}</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Finalizadora*</label>
                  <input name="nome" value={form.nome} onChange={handleChange} className="border rounded px-3 py-2 w-full" required maxLength={50} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Forma*</label>
                  <select name="indpag" value={form.indpag} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                    {FORMAS.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tipo*</label>
                  <select name="tipo" value={form.tipo} onChange={handleChange} className="border rounded px-3 py-2 w-full" required>
                    <option value="">Selecione...</option>
                    {TIPOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Plataforma</label>
                  <select name="plataforma" value={form.plataforma} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                    <option value="">Selecione...</option>
                    {PLATAFORMAS.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tipo Integração</label>
                  <select name="tpintegra" value={form.tpintegra} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                    {TPINTEGRA.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Credenciais Plataforma</label>
                  <input name="credenciais" value={form.credenciais} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={255} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Token Maquineta</label>
                  <input name="token_maquina" value={form.token_maquina} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={255} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">CNPJ Adquirente</label>
                  <input name="cnpj_adm" value={form.cnpj_adm} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={20} />
                </div>
                <div className="flex items-center space-x-4">
                  <label className="flex items-center">
                    <input type="checkbox" name="permite_troco" checked={form.permissoes.permite_troco} onChange={handleChange} className="mr-2" />
                    Troco
                  </label>
                  <label className="flex items-center">
                    <input type="checkbox" name="autoatendimento" checked={form.permissoes.autoatendimento} onChange={handleChange} className="mr-2" />
                    Autoatendimento
                  </label>
                </div>
                <div>
                  <label className="flex items-center">
                    <input type="checkbox" name="emite_nfc_automatico" checked={form.emite_nfc_automatico} onChange={handleChange} className="mr-2" />
                    Emite NFC-e automático
                  </label>
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-sm relative">
              <h3 className="text-lg font-bold mb-4">Confirmar exclusão?</h3>
              <div className="flex justify-end space-x-2 mt-4">
                <button onClick={cancelarRemocao} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button onClick={confirmarRemocao} className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition">Excluir</button>
              </div>
            </div>
          </div>
        )}
        {/* Modal de Importação */}
        {modalImportar && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-2xl relative max-h-[90vh] overflow-y-auto">
              <button onClick={fecharModalImportar} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">Importar Finalizadoras Padrão</h3>
              {erro && <div className="text-red-600 mb-2">{erro}</div>}
              <div className="mb-4">
                {finalizadorasImportOrdenadas.length === 0 ? (
                  <div className="text-gray-500">Nenhuma finalizadora padrão encontrada.</div>
                ) : (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-80 overflow-y-auto">
                    {finalizadorasImportOrdenadas.map(f => (
                      <label key={f.id} className="flex items-center gap-2 border rounded p-2 cursor-pointer hover:bg-blue-50">
                        <input
                          type="checkbox"
                          checked={selecionadasImport.includes(f.id)}
                          onChange={() => toggleSelecionada(f.id)}
                        />
                        <span className="font-bold text-blue-800">{f.nome}</span>
                        <span className="text-gray-600 text-xs">({TIPOS.find(x => x.value === f.tipo)?.label || f.tipo})</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button onClick={fecharModalImportar} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                <button onClick={confirmarImportacao} disabled={importando} className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition font-bold">
                  {importando ? 'Importando...' : 'Confirmar Importação'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmpresaFinalizadorasPage; 